import { render, staticRenderFns } from "./ProjectResources.vue?vue&type=template&id=2d2b47ad&scoped=true"
import script from "./ProjectResources.vue?vue&type=script&lang=js"
export * from "./ProjectResources.vue?vue&type=script&lang=js"
import style0 from "./ProjectResources.vue?vue&type=style&index=0&id=2d2b47ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b47ad",
  null
  
)

export default component.exports